import React from "react";
import { Skeleton } from "./skeleton";

const StatsBar = ({
  stats = [],
  isLoading = false,
  onStatClick,
  containerClassName = "",
}) => {
  return (
    <div className={`stats-bar ${containerClassName}`}>
      <div className="stats-bar__scroll-container">
        {stats.map((stat, index) => (
          <div key={stat.id} className="stats-bar__group">
            {/* Stat Item */}
            <div
              className="stats-bar__item"
              onClick={() => onStatClick && onStatClick(stat.id)}
              role="button"
              tabIndex={0}
            >
              <div
                className="stats-bar__icon-container"
                style={{ backgroundColor: stat.iconBg || "#E5E7EB" }}
              >
                {stat.icon && (
                  <span style={{ color: stat.iconColor }}>
                    {React.createElement(stat.icon, { 
                      className: "stats-bar__icon"
                    })}
                  </span>
                )}
              </div>
              <div className="stats-bar__content">
                <span className="stats-bar__value" title={stat.value}>
                  {isLoading ? <Skeleton className="h-4 w-6" /> : stat.value}
                </span>
                <span className="stats-bar__label" title={stat.label}>
                  {stat.label}
                </span>
              </div>
            </div>

            {/* Divider */}
            {index < stats.length - 1 && <div className="stats-bar__divider" />}
          </div>
        ))}
      </div>
    </div>
  );
};

export default StatsBar;
